export enum RedirectOrigins {
  MY_ACCOUNT = 'my-account',
  ENQUIRY = 'enquiry',
  ORDERS = 'orders',
  RESERVATIONS = 'reservations',
  SAVED_CARS = 'saved-cars',
}
